var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingHeroPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 430,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-336 0h2400v87.5555L-336 387.555V0Z",
    fill: "#FFF4ED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1464 162.006 466.67-58.353v71.111L1464 233.117v-71.111Z",
    fill: "#FFE6D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m984 151.787 680-85.3427v71.1107l-680 85.343v-71.111Z",
    fill: "#FFD6AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.78 58.3522 1628.44 0v71.1111l-466.66 58.3519V58.3522Z",
    fill: "#FFC299"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64 266.463 466.667-58.353v71.111L64 337.574v-71.111Z",
    fill: "#FFE6D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-104.889 358.672 466.667-58.352v71.111l-466.667 58.352v-71.111Z",
    fill: "#FFC299"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -447.111,
    y: -111.111,
    width: 2622.22,
    height: 609.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 55.5556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_316_125601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_316_125601",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHeroPattern);
export default __webpack_public_path__ + "static/media/landing-hero-pattern.f185119ff6e33bf87b41e64fbf2be0e2.svg";
export { ForwardRef as ReactComponent };